export class GetAgencyBO {
    SearchColumn: string = "agencyName";
    SearchText: string = "";
    orderColumn: string = "agencyName";;
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    statusLid: string;
    field: string = "agencyName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    type: string = "";
    start: string;
    end: string;
}

export class ColumnChangeBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    userid: string = "00000000-0000-0000-0000-000000000000";
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    column: string;
}

export class columnWidth {
    column: string = "";
    width: number = 0;
}


